
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { getLanguageFromLocation } from './utils/languageUtils'

// Set the HTML lang attribute based on detected language
const detectedLanguage = getLanguageFromLocation();
document.documentElement.lang = detectedLanguage;

createRoot(document.getElementById("root")!).render(<App />);
